import { render, staticRenderFns } from "./carMonthDetail.vue?vue&type=template&id=63afab63&"
import script from "./carMonthDetail.vue?vue&type=script&lang=js&"
export * from "./carMonthDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports